import {
    GET_DIARIES_LIST_DATA,
    GET_TODO_WEEK_DATA,
    GET_DIARY_DETAIL_REQUEST,
    GET_DIARY_LOGS,
    CHANGE_SELECTED_DIARY,
    RESET_LISTING_DATA,
    RESET_LISTING_LOG_DATA,
    COMPLETE_DIARY_REQUEST,
    CANCEL_DIARY_REQUEST,
    GET_TODO_MONTH_DATA,
    TOGGLE_VIEW,
    SHOW_MORE_CALENDAR_VIEW,
    FETCH_DIARY_INFO,
    GET_SPONSORS_REQUEST,
    CHANGE_DIARY_OWNER_REQUEST,
    UPDATE_CAPTION_TODO_REQUEST,
    RESET_DIARY_VIEW_DATA,
    RESET_DIARY_VIEW_DIARYINFO_DATA,
    CHANGE_ACTIVE_TAB,
    SET_SELECTED_DIARY_DETAIL,
    CHANGE_VIEW_ACTIVE_TAB,
    CREATE_DIARY_REQUEST,
    UPDATE_DIARY_REQUEST,
    RESET_DIARY_FORM_DATA,
    FETCH_DIARY_TAGS
} from "./actionConstants";

export const fetchDiaryTags = payload => ({
    type: FETCH_DIARY_TAGS
});

export const createDiary = payload => ({
    type: CREATE_DIARY_REQUEST,
    payload
})

export const updateDiary = payload => ({
    type: UPDATE_DIARY_REQUEST,
    payload
})

export const resetDiaryFormData = payload => ({
    type: RESET_DIARY_FORM_DATA,
    payload
})

export const getDiariesListData = payload => ({
    type: GET_DIARIES_LIST_DATA,
    payload
});

export const getTodoWeekData = payload => ({
    type: GET_TODO_WEEK_DATA,
    payload
});

export const getTodoMonthData = payload => ({
    type: GET_TODO_MONTH_DATA,
    payload
});

export const getDiaryLogs = payload => ({
    type: GET_DIARY_LOGS,
    payload
});

export const changeSelectedDiary = payload => ({
    type: CHANGE_SELECTED_DIARY,
    payload
});

export const resetListingData = payload => ({
    type: RESET_LISTING_DATA,
    payload
});

export const resetListingLogData = payload => ({
    type: RESET_LISTING_LOG_DATA,
    payload
});

export const getDiaryDetail = payload => ({
    type: GET_DIARY_DETAIL_REQUEST,
    payload
});

export const completeDiary = payload => ({
    type: COMPLETE_DIARY_REQUEST,
    payload
});

export const cancelDiary = payload => ({
    type: CANCEL_DIARY_REQUEST,
    payload
});

export const toggleDiaryView = payload => ({
    type: TOGGLE_VIEW,
    payload
});

export const showMoreCalendarView = payload => ({
    type: SHOW_MORE_CALENDAR_VIEW,
    payload
});

export const fetchDiaryInfo = payload => ({
    type: FETCH_DIARY_INFO,
    payload
})

export const getDiarySponsors = payload => ({
    type: GET_SPONSORS_REQUEST,
    payload
})


export const changeDiarySponsor = payload => ({
    type: CHANGE_DIARY_OWNER_REQUEST,
    payload
})

export const updateCaptionTodo = payload => ({
    type:UPDATE_CAPTION_TODO_REQUEST,
    payload
})

export const resetViewData= payload => ({
    type: RESET_DIARY_VIEW_DATA,
    payload
})

export const resetViewDiaryInfo = payload => ({
    type: RESET_DIARY_VIEW_DIARYINFO_DATA,
    payload
})

export const changeActiveTab = payload => ({
    type: CHANGE_ACTIVE_TAB,
    payload
})

export const setSelectedDiaryDetail = payload => ({
    type:SET_SELECTED_DIARY_DETAIL,
    payload
})

export const changeViewActiveTab = payload => ({
    type:CHANGE_VIEW_ACTIVE_TAB,
    payload
})